import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20red%20velvet%20curtains%20partially%20opened%2C%20warm%20theatrical%20spotlight%20beam%20from%20top%20right%2C%20mysterious%20silhouette%20in%20the%20center%2C%20deep%20brown%20and%20dark%20amber%20toned%20background%2C%20editorial%20magazine%20cover%20aesthetic%2C%20cinematic%20lighting%2C%20dramatic%20shadows%2C%20luxurious%20theater%20atmosphere&width=1800&height=1000&seq=hero-bg-2026&orientation=landscape"
          alt="吃瓜网 - 娱乐圈八卦追踪"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight tracking-wide">
          {t('heroTitle1')}
        </h1>
        <p className="mt-1 text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight tracking-wide">
          {t('heroTitle2')}
        </p>
        <p className="mt-6 max-w-xl text-sm md:text-base text-background-200/80 leading-relaxed">
          {t('heroSubtitle')}
        </p>
        <Link
          to="/category/all"
          className="whitespace-nowrap mt-8 inline-flex items-center gap-2 px-8 py-3 bg-accent-500/90 text-background-50 text-sm md:text-base font-medium rounded-full hover:bg-accent-600 transition-all duration-300 cursor-pointer"
        >
          {t('heroCta')}
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}